var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('principal',{on:{"showSection":_vm.showSection}}),(_vm.step===1)?_c('video-explication'):_vm._e(),(_vm.step===2)?_c('video-women'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }